import "./utils/quillInit"; // MUST remain at top
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ContextProvider } from "./context/Context";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_API;
axios.defaults.headers.common["Content-Type"] = "application/json";

const normalizeUserStructure = () => {
  try {
    const raw = JSON.parse(localStorage.getItem("user"));
    if (raw && raw.user && raw.token) {
      const flattened = { ...raw.user, token: raw.token };
      localStorage.setItem("user", JSON.stringify(flattened));
    }
  } catch (error) {
    console.error("Error normalizing legacy user data:", error.message);
  }
};
normalizeUserStructure();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ContextProvider>
    <App />
  </ContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
